import React from 'react';
import { Card } from 'antd';
import { SkBar } from './_primitives';

const TermsHeader = () => (
  <>
    <div className="flex items-center gap-3 mb-2">
      <div className="w-6 h-6 rounded bg-gray-200 animate-pulse flex-shrink-0" />
      <SkBar h="h-7" w="w-80" className="max-w-full" />
    </div>
    <SkBar h="h-3" w="w-64" className="max-w-full mb-4" />
  </>
);

const ActionRow = () => (
  <div className="flex items-center justify-end mb-4">
    <SkBar h="h-9" w="w-32" className="rounded-md" />
  </div>
);

const TERMS_COLS = ['w-12', 'w-16', 'w-14', 'w-16'];

const EmptyTable = () => (
  <div className="overflow-x-auto">
    <div className="min-w-[700px]">
      {/* Header row */}
      <div className="grid grid-cols-[2fr_3fr_1fr_1fr] gap-3 pb-3 border-b border-gray-200 bg-gray-50 px-2 py-2 rounded-t">
        {TERMS_COLS.map((w, i) => (
          <SkBar key={i} h="h-3" w={w} />
        ))}
      </div>
      {/* Empty body */}
      <div className="flex flex-col items-center justify-center gap-4 py-16">
        <div className="w-14 h-14 rounded-lg bg-gray-100 animate-pulse" />
        <SkBar h="h-3" w="w-40" />
        <SkBar h="h-10" w="w-44" className="rounded-md" />
      </div>
    </div>
  </div>
);

/**
 * TermsConfigPageLoader — matches Terms & Conditions Configuration layout:
 *  outer card with icon + title + subtitle · right-aligned "Add Section" button ·
 *  4-col table header (Title / Content / Status / Actions) ·
 *  empty state with icon, message, and "Create First Section" CTA.
 */
const TermsConfigPageLoader = () => (
  <div className="w-full p-3 sm:p-4 md:p-6">
    <Card className="shadow-sm" styles={{ body: { padding: 24 } }}>
      <TermsHeader />
      <ActionRow />
      <EmptyTable />
    </Card>
  </div>
);

export default TermsConfigPageLoader;
